export const environment = {
    production: false,
    instrumentation_key: '062eae9a-38bd-4a65-bc46-a353f576c76f',
    help_links: {
        overview:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter0',
        using_dashboards:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter4',
        viewing_dashboards:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter5',
        editing_dashboards:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter6',
        saving_dashboards:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter7',
        exporting_dashboards:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter9',
        using_reports:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter16',
        viewing_reports:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter17',
        editing_reports:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter18',
        saving_reports:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter19',
        loading_reports:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter20',
        using_datasets:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter22',
        updating_date_range:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter25',
        changing_saving_peer_groups:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter28',
        analyse_function:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter38',
        inidicator_definitions:
            'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter44',
        faq: 'https://members.housemark.co.uk/data/benchmarking/Pages/RunningBenchmarkingReports.aspx#chapter45',
    },
    nexus_url: 'https://eformbeta.housemark.co.uk',
    userpilot_token: 'STG-NX-3da5ef7d'
};
